
import React from 'react'
import ActionText from 'ui/ActionText'
import css from './LoginFooter.module.css'

const LoginFooter = () => (
  <footer className={css.main}>
    <ActionText
      text='Forgot your password?'
      linkHref='/forgot'
      linkText='Reset your password' />

    <ActionText
      text='Don’t have an account?'
      linkHref='/signup'
      linkText='Sign up' />
  </footer>
)

export default LoginFooter



// WEBPACK FOOTER //
// ./components/LoginFooter.js